import React from "react";
import { withRouter } from "react-router-dom";
class UserHeader extends React.Component {
  render() {
    return (
      <div>
        <h1> user Header</h1>
      </div>
    );
  }
}

export default withRouter(UserHeader);
